
export const transactionSourceEnum = Object.freeze({
  BANK: "iframe-bank",
  EXCHANGE: "iframe-exchange",
  WALLET: "iframe-wallet",
  QR_CODE: "iframe-qr-code",
  DEFAULT: "iframe",
  IFRAME_WALLET_CONNECT: 'iframe-wallet-connect'
});
export const sessionTimeoutNotificationType = Object.freeze({
  NEW_USER: "new-user",
  OTP: "otp",
});
